import React from 'react';
import { Loader } from 'pixi.js'
import { Container,  Sprite } from '@inlet/react-pixi'
import Cloud from './Cloud'

const MoonAndCloud = () => {
    const loader = Loader.shared;
    //moon
    const moonTexture = loader.resources["./assets/images/components/island/spritesheets/skyAssets/text_sun_moon_road.json"].textures[`moon.png`];

    return (
        <Container>
            <Sprite   // moon
                texture={moonTexture}
                scale={{ x: 0.3, y: 0.3 }}
                x={1400}
                y={80}
            />
            <Cloud _xPos={180} _yPos={230} speed={0.006} max={250} min={100} _xSize={0.2} _ySize={0.2} _time={'night'} />
            <Cloud _xPos={400} _yPos={480} speed={0.005} max={550} min={400} _xSize={0.14} _ySize={0.14} _time={'night'} />
            <Cloud _xPos={550} _yPos={150} speed={0.004} max={600} min={550} _xSize={0.16} _ySize={0.16} _time={'night'} />
            <Cloud _xPos={1100} _yPos={140} speed={0.005} max={1200} min={1100} _xSize={0.17} _ySize={0.17} _time={'night'} />
            <Cloud _xPos={900} _yPos={600} speed={0.003} max={1000} min={900} _xSize={0.15} _ySize={0.15} _time={'night'} />
            <Cloud _xPos={1300} _yPos={450} speed={0.005} max={1450} min={1300} _xSize={0.2} _ySize={0.2} _time={'night'} />
        </Container>
    );
}

export { MoonAndCloud as default }